import { getErrorMessage } from "./error";

const CLAIM_CAMPAIGN_ABORT_CODES = [
  "EINVALID_CAMPAIGN_STATUS",
  "ENO_ALLOCATION",
  "EALREADY_CLAIMED",
  "ECLAIM_WINDOW_NOT_OPEN",
  "ECLAIM_WINDOW_EXPIRED",
] as const;

export type ClaimCampaignAbortCode = (typeof CLAIM_CAMPAIGN_ABORT_CODES)[number];

const CLAIM_CAMPAIGN_ABORT_CODE_SET = new Set<string>(CLAIM_CAMPAIGN_ABORT_CODES);

const MOVE_ABORT_NAMED_PATTERN = /Move abort[^:]*::campaign_manager:\s*(E[A-Z0-9_]+)/;

export function parseClaimCampaignAbort(error: unknown): ClaimCampaignAbortCode | undefined {
  const message = getErrorMessage(error);
  if (!message) return undefined;
  const match = MOVE_ABORT_NAMED_PATTERN.exec(message);
  const symbol = match?.[1];
  if (symbol && CLAIM_CAMPAIGN_ABORT_CODE_SET.has(symbol)) {
    return symbol as ClaimCampaignAbortCode;
  }
  return undefined;
}
